
import Main from '@/components/main'
//import path from 'path';

const routerMaps= [
    {
      path:'/',
      name:'login',
      component:()=>import('@/views/LoginView.vue'),
      meta:{
        keepAliva:false,
        title: "登录",
        icon: ''
      },
      noMenu:true,
      hide:true
    },
    {
      path:'/login_mid',
      name:'login_mid',
      component:()=>import('@/views/QRLoginRedirect.vue'),
      meta:{
        keepAliva:false,
        title: "登录中...",
        icon: ''
      },
      noMenu:true,
      hide:true
    },
    {
      path:'/result',
      name:'result',
      component:()=>import('@/views/ResultView.vue'),
      meta:{
        keepAliva:false,
        title: "",
        icon: ''
      },
      noMenu:true,
      hide:true
    },
    {
      path:'/error',
      name:'error',
      component:()=>import('@/views/ErrorView.vue'),
      meta:{
        keepAliva:false,
        title: "错误",
        icon: ''
      },
      noMenu:true,
      hide:true
    },
    //首页
    {
      path:'/home',
      name:'home_index',
      component:Main,
      meta:{
        keepAliva:false,
        title: "首页",
        icon: '',
        requireAuth:false,
		    roles:['root','goods','admin']
      },	  
	    noMenu:true,
      children:[
        {
          path:'/home',
          name:'home',
          component:()=>import('@/views/HomeView.vue'),
          meta:{
            title:'首页',
            icon:'',
            requireAuth:false
          }
        }        
      ]
    },
    //用户列表
    {
      path:'/user',
      name:'user_root',
      component:Main,
      meta:{
        keepAliva:false,
        title: "用户管理",
        icon: '',
        requireAuth:true,
		roles:['root','admin']
      },
      children:[
        {
          path:'/user/all',
          name:'user_list',
          component:()=>import('@/views/UserManager/UserListView.vue'),
          meta:{
            title:'用户列表',
            icon:'',
            requireAuth:true
          }
        },
        {
          path:'/user/add_user',
          name:'add_user',
          component:()=>import('@/views/UserManager/AddUserView.vue'),
          meta:{
            title:'添加用户',
            icon:'',
            keepAliva:false,
            isCache:true,
            requireAuth:true
          }
        },
        {
          path:'/user/detail',
          name:'user_detail',
          component:()=>import('@/views/UserManager/UserDetailView.vue'),
          meta:{
            keepAliva:false,
            title: "用户详情",
            icon: '',
            requireAuth:true,
            hide:true
          }
        },
        {
          path:'/user/add_driver',
          name:'user_add_driver',
          component:()=>import('@/views/UserManager/AddDriverView.vue'),
          meta:{
            title:'认证司机信息',
          icon:'',
          keepAliva:false,
          isCache:true,
          requireAuth:true
        }
        },
        {
          path:'/user/add_company',
          name:'user_add_company',
          component:()=>import('@/views/UserManager/AddCompanyView.vue'),
          meta:{
            title:'认证货主信息',
            icon:'',
            keepAliva:false,
            isCache:true,
            requireAuth:true
            }
        }
      ]
    },
    //车辆列表
    {
      path:'/vehicle',
      name:'vehicle_root',
      component:Main,
      meta:{
        keepAliva:false,
        title: "车辆管理",
        icon: '',
        requireAuth:true,
		roles:['root','admin']
      },
      children:[
        {
          path:'/vehicle/all',
          name:'vehicle_all',
          component:()=>import('@/views/VehicleManager/VehicleListView.vue'),
          meta:{
            keepAliva:false,
            title: "车辆列表",
            icon: '',
            requireAuth:true
          }   
        },
        {
          path:'/vehicle/add',
          name:'vehicle_add',
          component:()=>import('@/views/VehicleManager/AddVehicleView.vue'),
          meta:{
            KeepAliva:true,
            title: "添加车辆",
            icon: '',
            isCache:true,
            requireAuth:true
          },
    
        },
        {
          path:'/vehicle/detail/:id',
          name:'vehicle_detail',
          component:()=>import('@/views/VehicleManager/VehicleDetailView.vue'),
          meta:{
            keepAliva:false,
            title: "车辆详情",
            icon: '',
            hide:true,
            requireAuth:true
          },
        },        
        {
          path:'/vehicle/auth',
          name:'vehicle_auth',
          component:()=>import('@/views/VehicleManager/VehicleAuthView.vue'),
          meta:{
            keepAliva:false,
            title: "车辆审核",
            icon: '',
            hide:true,
            requireAuth:true
          },
        },        
        {
          path:'/vehicle/bind_dev/:id',
          name:'vehicle_bind_dev',
          component:()=>import('@/views/VehicleManager/VehicleGPSDevice.vue'),
          meta:{
            keepAliva:false,
            title: "车辆设备绑定",
            icon: '',
            hide:true,
            requireAuth:true
          },
        },        
    
      ]
    },
    //订单管理
    {
      path:'/order',
      name:'order',
      component:Main,
      meta:{
        keepAliva:false,
        title: "订单管理",
        icon: '',
        requireAuth:true,
		roles:['root','admin']
      },
      children:[
        {
          path:'/order/list',
          name:'order_list',
          component:()=>import('@/views/OrderManager/OrderListView.vue'),
          meta:{
            keepAliva:false,
            title:'订单列表',
            icon:'',
            requireAuth:true
          }
        },
        {
          path:'/order/add_new',
          name:'order_add_new',
          component:()=>import('@/views/OrderManager/CreateOrderView.vue'),
          meta:{
            keepAliva:false,
            title:'创建订单',
            icon:'',
            isCache:true,
            requireAuth:true
          }
        },
        {
          path:'/order/detail/:id',
          name:'order_detail',
          component:()=>import('@/views/OrderManager/OrderDetailView.vue'),
          meta:{
            keepAliva:false,
            title:'订单详情',
            icon:'',
            hide:true,
            requireAuth:true
          }
        },
        {
          path:'/order/edit/:id',
          name:'order_edit',
          component:()=>import('@/views/OrderManager/OrderEditView.vue'),
          meta:{
            keepAliva:false,
            title:'编辑订单',
            icon:'',
            hide:true,
            isCache:true,
            requireAuth:true
          }
        },
        {
          path:'/order/auth',
          name:'order_auth',
          component:()=>import('@/views/OrderManager/OrderAuthView.vue'),
          meta:{
            keepAliva:false,
            title:'订单审核',
            icon:'',
            hide:true,
            requireAuth:true
          }
        },
        {
          path:'/order/track/:id',
          name:'order_track',
          component:()=>import('@/views/OrderManager/OrderVehicleTrackView.vue'),
          meta:{
            keepAliva:false,
            title:'运单路径',
            icon:'',
            hide:true,
            requireAuth:true
          }
        },
      ]
    },
    //运单管理
    {
      path:'/waybill',
      name:'waybill',
      component:Main,
      meta:{
        keepAliva:false,
        title: "运单管理",
        icon: '',
        requireAuth:true,
		roles:['root','admin']
      },
      children:[
        {
          path:'/waybill/list',
          name:'waybill_list',
          component:()=>import('@/views/WaybillManager/WaybillListView.vue'),
          meta:{
            keepAliva:false,
            title:'运单列表',
            icon:'',
            requireAuth:true
          }  
        },
        {
          path:'/waybill/detail/:id',
          name:'waybill_detail',
          component:()=>import('@/views/WaybillManager/WaybillDetailView.vue'),
          meta:{
            keepAliva:false,
            title:'运单详情',
            icon:'',
            hide:true,
            requireAuth:true
          }
        },
        {
          path:'/waybill/track/:id',
          name:'waybill_track',
          component:()=>import('@/views/WaybillManager/WaybillTrackView.vue'),
          meta:{
            keepAliva:false,
            title:'运单路径',
            icon:'',
            hide:true,
            requireAuth:true
          }
        },
      ]
    },
    //gps管理
    {
      path:'/gps',
      name:'gps',
      component:Main,
      meta:{
        keepAliva:false,
        title: "GPS设备管理",
        icon: '',
        requireAuth:true,
		roles:['root','admin']
      },
      children:[
        {
          path:'/gps/list',
          name:'gps_list',
          component:()=>import('@/views/GPSDevicesManager/GPSDevicesListView.vue'),
          meta:{
            keepAliva:false,
            title:'GPS设备列表',
            icon:'',
            requireAuth:true
          }  
        },
        {
          path:'/gps/new',
          name:'gps_new',
          component:()=>import('@/views/GPSDevicesManager/GPSDevicesAddView.vue'),
          meta:{
            keepAliva:false,
            title:'添加GPS设备',
            icon:'',
            requireAuth:true
			
          }  
        }
      ]
    },  
    //地址薄管理  
    {
      path:'/addr',
      name:'address',
      component:Main,
      meta:{
        keepAliva:false,
        title:'地址薄',
        icon:'',
        requireAuth:true,
		roles:['root','admin']
      },
      children:[
        {
          path:'/addr/list',
          name:'addr_list',
          component:()=>import('@/views/AddressManager/AddressListView.vue'),
          meta:{
            keepAliva:false,
            title:'地址列表',
            icon:'',
            requireAuth:true
          }  
        },
        {
          path:'/addr/add',
          name:'addr_add',
          component:()=>import('@/views/AddressManager/NewAddressView.vue'),
          meta:{
            keepAliva:false,
            title:'添加地址',
            icon:'',
            isCache:true,
            requireAuth:true
          }  
        },
        {
          path:'/addr/edit',
          name:'addr_edit',
          component:()=>import('@/views/AddressManager/NewAddressView.vue'),
          meta:{
            keepAliva:false,
            title:'修改地址',
            icon:'',
            isCache:true,
            hide:true,
            requireAuth:true
          }  
        }
      ]
    },
    //文本模板管理
	{
		path:"/txt-mode",
		name:"txtMode",
		component:Main,
		meta:{
			keepAliva:false,
			title:'文本模板',
			icon:'',
			requireAuth:true,
			roles:['root','admin']
		},
		children:[
			{
			  path:'/txt-mode/list',
			  name:'txtMode_list',
			  component:()=>import('@/views/TextModeManager/TextModeList.vue'),
			  meta:{
				keepAliva:false,
				title:'模板列表',
				icon:'',
				requireAuth:true
			  }  
			},
			{
			  path:'/txt-mode/content_create/:id?',
			  name:'txtMode_content_create',
			  component:()=>import('@/views/TextModeManager/ContentEditor.vue'),
			  meta:{
				keepAliva:false,
				title:'创建模板',
				icon:'',
				hide:true,
				requireAuth:true
			  }  
			}

		]
	},
  //客户订单
	{
		path: '/orderc',
		name: 'orderc',
		component:Main,
		meta:{
		  keepAliva:false,
		  title: "订单",
		  icon: '',
		  requireAuth:true,
			roles:['goods']
		},
		children:[
			{
			  path:'/orderc/list',
			  name:'orderc_list',
			  component:()=>import('@/views/OrderCompany/OrderCListView.vue'),
			  meta:{
				keepAliva:false,
				title:'订单列表',
				icon:'',
				requireAuth:true
			  }  
			}
		]
	},
  //客户运单
	{
		path: '/waybillc',
		name: 'waybillc',
		component:Main,
		meta:{
		  keepAliva:false,
		  title: "运单",
		  icon: '',
		  requireAuth:true,
			roles:['goods']
		},
		children:[
			{
			  path:'/waybillc/list',
			  name:'waybillc_list',
			  component:()=>import('@/views/WaybillCompany/WaybillCListView.vue'),
			  meta:{
				keepAliva:false,
				title:'运单列表',
				icon:'',
				requireAuth:true
			  }  
			}
		]
	},

  //客户结算
	{
		path: '/accountc',
		name: 'accountc',
		component:Main,
		meta:{
		  keepAliva:false,
		  title: "结算",
		  icon: '',
		  requireAuth:true,
			roles:['goods']			
		},
		children:[
			{
				path:'/accountc/list',
				name:'accountc_list',
				component:()=>import('@/views/Account/AccountCView.vue'),
				meta:{
					keepAliva:false,
					title:'结算列表',
					icon:'',
					requireAuth:true
				}
			},
			{
				path:'/accountc/over',
				name:'accountc_over',
				component:()=>import('@/views/Account/AccountOverCView.vue'),
				meta:{
					keepAliva:false,
					title:'结算完成',
					icon:'',
					requireAuth:true
				}
			},
			{
				path:'/accountc/custom',
				name:'accountc_custom',
				component:()=>import('@/views/Account/AccountCustomCView.vue'),
				meta:{
					keepAliva:false,
					title:'手动开票',
					icon:'',
					requireAuth:true
				}
			}

		]
	},
  {
		path: '/account',
		name: 'account',
		component:Main,
		meta:{
		  keepAliva:false,
		  title: "结算",
		  icon: '',
		  requireAuth:true,
			roles:['root','admin']			
		},
		children:[
			{
				path:'/account/list',
				name:'account_list',
				component:()=>import('@/views/Account/AccountListView.vue'),
				meta:{
					keepAliva:false,
					title:'结算列表',
					icon:'',
					requireAuth:true
				}
			}

		]
  },
    {
      path: '/display',
      name: 'display',
      component:()=>import('@/views/display/DisplayView.vue'),
      meta:{
        keepAliva:false,
        title: "车辆演示",
        icon: '',
        requireAuth:true,
        roles:['goods']
      }
    },    
    {
      path:'/about',
	  name:'about_index',
      component:Main,
      meta:{
        keepAliva:false,
        title: "关于",
        icon: ''
      },
	  noMenu:true,
      children:[
        {
          path:'/about',
          name:'about',
          component:()=>import('@/views/AboutView.vue'),
          meta:{
            title:'关于',
            icon:''
          }
        }        
      ]
    },
    {
      path:'/:pathMatch(.*)*',
      redirect:'/'
    }  
  ]

  export default routerMaps;